import { render, staticRenderFns } from "./ListarTickets.vue?vue&type=template&id=bbc24f76"
import script from "./ListarTickets.vue?vue&type=script&lang=js"
export * from "./ListarTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports